import { Box, Typography, TextField } from "@mui/material";

export default function BoostSettingsGroup({
  title,
  startIndex,
  count,
  color,
  versusSettings,
  setVersusSettings,
}) {
  return (
    <Box
      sx={{
        p: 3,
        border: "1px solid #e0e0e0",
        borderRadius: 2,
        backgroundColor: "#fafafa",
        height: "fit-content",
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ mb: 2, fontWeight: 600, textAlign: "center" }}
      >
        {title}
      </Typography>
      {Array.from({ length: count }, (_, index) => {
        const actualIndex = index + startIndex;
        return (
          <Box
            key={actualIndex}
            sx={{
              display: "flex",
              alignItems: "center",
              mb: 2,
              p: 2,
              backgroundColor: "white",
              borderRadius: 1,
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 40,
                height: 40,
                backgroundColor: color,
                color: "white",
                borderRadius: "50%",
                mr: 2,
                fontWeight: "bold",
              }}
            >
              {actualIndex}
            </Box>
            <TextField
              label="Top Fixtures %"
              type="number"
              value={versusSettings?.boostSettings?.[actualIndex] || 0}
              onChange={(e) => {
                const newSettings = { ...versusSettings };
                if (!newSettings.boostSettings) {
                  newSettings.boostSettings = new Array(11).fill(0);
                }
                newSettings.boostSettings[actualIndex] = Number(e.target.value);
                setVersusSettings(newSettings);
              }}
              fullWidth
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    %
                  </Typography>
                ),
              }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
